import 'reakit/styled';
import { palette, theme } from 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import styled from '../styled/index.js';
import Box from 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
var Icon = styled(Box).withConfig({
  displayName: "styled__Icon",
  componentId: "huruki-0"
})(["fill:", ";position:relative;font-size:", "em;height:1em;width:1em;", ";"], function (props) {
  return props.color ? palette(props.color)(props) : 'inherit';
}, function (props) {
  return props.size;
}, theme('fannypack.Icon.base'));
export default Icon;
export { Icon };